import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { DollarSign, Users, Zap, Palette, Download, Smartphone } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: DollarSign,
    title: 'No Rental Fees',
    description: "Skip the $400 phone rental. Ihsanly works from your guests' own phones."
  }, {
    icon: Users,
    title: 'Unlimited Guests',
    description: "Everyone's invited to leave a message. No guest limits, ever."
  }, {
    icon: Zap,
    title: 'Instant Access',
    description: "Messages appear in your dashboard the moment they're recorded."
  }, {
    icon: Palette,
    title: 'Beautiful Design',
    description: 'Customize your guestbook page to match your wedding theme and colors.'
  }, {
    icon: Download,
    title: 'Download Anytime',
    description: 'Export all voicemails as audio files whenever you want.'
  }, {
    icon: Smartphone,
    title: 'Works on Any Phone',
    description: 'No app to install. Works on iPhone, Android, any modern browser.'
  }];
  return <section className="py-24 bg-cream-100 text-brown-900" data-id="element-149">
      <div className="max-w-7xl mx-auto px-4" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-151">
          <h2 className="text-4xl md:text-5xl font-serif italic mb-4" data-id="element-152">
            Everything You Need, Nothing You Don't
          </h2>
          <p className="text-brown-900/70 text-lg max-w-2xl mx-auto" data-id="element-153">
            Designed to capture memories without adding to your wedding
            checklist.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-154">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-cream-200" data-id="element-155">
              <div className="w-12 h-12 rounded-full bg-accent-pink/10 flex items-center justify-center mb-6 text-accent-pink" data-id="element-156">
                <feature.icon className="w-6 h-6" data-id="element-157" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-brown-900" data-id="element-158">
                {feature.title}
              </h3>
              <p className="text-brown-900/70 leading-relaxed" data-id="element-159">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}